import type { DailyRoutineDetails } from '../dto/DailyRoutineDetails';
import { RoutineError, toRoutineError } from '../errors/RoutineError';
import type { DailyRoutineRepository } from '../ports/DailyRoutineRepository';
import type { DailyStepRepository } from '../ports/DailyStepRepository';
import type { EmotionalProtocolLogRepository } from '../ports/EmotionalProtocolLogRepository';
import type { ProfileId } from '../../domain/shared/ids';
import { failure, success, type Result } from '../../domain/shared/Result';
import { loadRoutineDetails } from './routineDetails';

export class GetDailyRoutine {
  public constructor(
    private readonly dailyRoutines: DailyRoutineRepository,
    private readonly dailySteps: DailyStepRepository,
    private readonly emotionalProtocolLogs: EmotionalProtocolLogRepository,
  ) {}

  public async execute(
    profileId: ProfileId,
    logicalDate: string,
  ): Promise<Result<DailyRoutineDetails, RoutineError>> {
    try {
      const routine = await this.dailyRoutines.findByLogicalDate(profileId, logicalDate);
      if (!routine) {
        return failure(new RoutineError('routine_not_found', 'Aucune ascension pour cette date.'));
      }
      return success(
        await loadRoutineDetails(routine, this.dailySteps, this.emotionalProtocolLogs),
      );
    } catch (error) {
      return failure(toRoutineError(error));
    }
  }
}
